import React from "react";
import SetupWizard from "../Setup/SetupWizard";

const PlatformRegisterSchool = () => {
  return <SetupWizard />;
};

export default PlatformRegisterSchool;
